export default function () {
  return {
    notifications: [],
    chatrooms: [],
    firebaseChatrooms: [],
    chatroomsSnapshot: null
  }
}
